import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadComponent } from './upload.component';
import { FormsModule } from '@angular/forms';
import { NzMessageModule, NzProgressModule, NzMessageService} from 'ng-zorro-antd';
import { UploadService } from './upload.service';
@NgModule({
  imports: [
    CommonModule,
    NzMessageModule,
    FormsModule,
    NzProgressModule
  ],
  declarations: [UploadComponent],
  exports: [UploadComponent],
  providers: [ UploadService, NzMessageService]
})
export class UploadModule { }
